import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  GetDetailTypeAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { HistoryDetailsPopup } from "./HistoryDetailsPopup";
import { InfrastructurePopup } from "./InfrastructurePopup";
import { PaymentDetailsPopup } from "./PaymentDetailsPopup";
import { ProfileDetailPopup } from "./ProfileDetailPopup";
import { StaffDetailsPopup } from "./StaffDetailsPopup";
import { VerificationDetailsPopup } from "./VerificationDetailsPopup";
import moment from "moment";
import { useState } from "react";
import {
  clearCurrentPage,
  clearDuration,
  getApiParams,
  initialFilterState,
} from "./helper";
import PaginatedItems from "../../../common/Pagination";
import DateRangePickerInput from "./DateRangePicker";
import Modal from "react-modal";
import { SearchIcon } from "../../../Utils/SvgIcons";
import { TestDetailsPopup } from "./TestDetailsPopup";
import { TestDetailsPopupIBU } from "./TestDetailsPopupIBU";
import { PackageDetailsPopup } from "./PackageDetailPopup";
import { PackageDetailPopupIBU } from "./PackageDetailPopupIBU";
import { ProviderUploadDocPopupIBU } from "./ProviderUploadDocPopupIBU";
import { FinanceQcPopup } from "./FinanceQcPopup";
import { FinanceAppointment } from "./FinanceAppointment";
import { CreatePayablePopup } from "./CreatePayablePopup";
import { AdditionalFinanceApptHeader } from "./AdditionalFinanceApptHeader";
import {
  GetAppointmentInsurerAction,
  GetFinanceQcAction,
  GetInsurerBillingClientAction,
  GetQCApprovalDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import { getNetworkMenuId } from "../../../Utils/types";
import { InsurerBillingClient } from "./InsurerBillingClient";
import { InsurerBillingAppointment } from "./InsurerBillingAppointment";
import { UpdateInvoice } from "./UpdateInvoice";

const ProviderProfileDetails = () => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState(null);
  const [rowTicketId, setRowTicketId] = useState(null);
  const [qcFinancePage, setQcFinancePage] = useState(null);
  const [insBillingPage, setInsBillingPage] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [payableData, setPayabelData] = useState([]);
  const [header, setHeader] = useState([]);
  const [reCallApi, setReCallApi] = useState(false);
  const [firstPageData, setFirstPageData] = useState(null);
  const [showData, setShowData] = useState(false);
  const [invoice, setInvoice] = useState({
    isOpen: false,
    rowData: null,
  });
  const [isReCall, setIsReCall] = useState(false);//added by sanoj
  const getProviderPortalDetails = useSelector(
    (state) => state?.providerPortalDetailReducer
  );
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  useEffect(() => {
if(!isReCall){
    dispatch(getProviderProfileDetailAction({ ...searchFilter, ...apiParams }));
    }
  }, [globalReducer?.getCurrentPage]);

  useEffect(() => {
    dispatch(GetDetailTypeAction());
  }, []);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    if ((rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC") && qcFinancePage === null) {
      setQcFinancePage("firstPage");
      setReCallApi(true);
    }
    if (rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC") {
      setSearchFilter({ ...searchFilter, requestID: rowData?.requestID });
    }
    if (qcFinancePage === "secondPage") {
      setSearchFilter({
        ...searchFilter,
        sessionId: rowData?.sessionId,
        ticketId: rowData?.requestID,
        providerId: rowData?.providerId,
      });
    }
    if (rowData?.detailType === "InsurerBillingQC" && insBillingPage === null) {
      setInsBillingPage("firstPage");
      setReCallApi(true);
    }
    if (rowData?.detailType === "InsurerBillingQC") {
      setSearchFilter({ ...searchFilter, requestID: rowData?.requestID });
    }
    if (insBillingPage === "secondPage") {
      setSearchFilter({
        ...searchFilter,
        sessionId: rowData?.sessionId,
        ticketId: rowData?.requestID,
        providerId: rowData?.providerId,
      });
    }
  }, [qcFinancePage, rowData, insBillingPage]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    if (qcFinancePage === "firstPage") {
      dispatch(
        GetFinanceQcAction({
          ...searchFilter,
          sessionId: firstPageData?.sessionID,
          ticketId: firstPageData?.requestID,
          providerId: firstPageData?.providerId,
        })
      );
    } else if (qcFinancePage === "secondPage") {
      dispatch(
        GetQCApprovalDetailsNetworkAction({
          ...searchFilter,
          sessionId: rowData?.sessionId,
          ticketId: rowData?.requestID,
          providerId: rowData?.providerId,
        })
      );
    } else if (insBillingPage === "firstPage") {
      dispatch(
        GetInsurerBillingClientAction({
          ...searchFilter,
          sessionId: firstPageData?.sessionID,
          ticketId: firstPageData?.requestID,
          providerId: firstPageData?.providerId,
        })
      );
    } else if (insBillingPage === "secondPage") {
      dispatch(
        GetAppointmentInsurerAction({
          ...searchFilter,
          sessionId: rowData?.sessionId,
          ticketId: rowData?.requestID,
          providerId: rowData?.providerId,
        })
      );
    } else {
      dispatch(
        getProviderProfileDetailAction({
          ...searchFilter,
          ...apiParams,
          page: 1,
        })
      );
    }
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    dispatch(
      getProviderProfileDetailAction({ ...initialFilterState, requestID: null })
    );
    clearDuration(dispatch);
    clearCurrentPage(dispatch);
    setHeader([]);
    setFirstPageData(null);
  };
  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    dispatch(
      getProviderProfileDetailAction({
        ...searchFilter,
        ...apiParams,
        SortDirection: type,
      })
    );
  };
  const handleBackButton = () => {
    setIsReCall(false);//adfded by sanoj
    if ((rowData.detailType === "FinanceQC" || rowData.detailType === "ProviderQC") && qcFinancePage === "secondPage") {
      setHeader([]);
      setQcFinancePage("firstPage");
      setReCallApi(false);
      setSearchFilter({
        ...searchFilter,
        providerName: "",
        requestStatus: "",
        requestID: null,
      });
    } else if (qcFinancePage === "firstPage") {
      setRowData(null);
      setReCallApi(true);
      // handleClearFilter();
      setQcFinancePage(null);
      setPayabelData([]);
      if(rowData.detailType==="FinanceQC")
      {
         setSearchFilter({ ...initialFilterState, detailType: "FinanceQC" });
         dispatch(
          getProviderProfileDetailAction({
            ...initialFilterState,
            requestID: null,
            detailType: "FinanceQC",
          })
        );
      }
      else 
      {
         setSearchFilter({ ...initialFilterState, detailType: "ProviderQC" });
         dispatch(
          getProviderProfileDetailAction({
            ...initialFilterState,
            requestID: null,
            detailType: "ProviderQC",
          })
        );
      }
     
      clearDuration(dispatch);
      clearCurrentPage(dispatch);
      setHeader([]);
      setFirstPageData(null);
    } else if (
      rowData.detailType === "InsurerBillingQC" &&
      insBillingPage === "secondPage"
    ) {
      setHeader([]);
      setInsBillingPage("firstPage");
      setReCallApi(false);
      setSearchFilter({
        ...searchFilter,
        providerName: "",
        requestStatus: "",
        requestID: null,
      });
    } else if (insBillingPage === "firstPage") {
      setRowData(null);
      setReCallApi(true);
      // handleClearFilter();
      setInsBillingPage(null);
      setPayabelData([]);
      setFirstPageData(null);
      setSearchFilter({
        ...initialFilterState,
        detailType: "InsurerBillingQC",
      });
      dispatch(
        getProviderProfileDetailAction({
          ...initialFilterState,
          requestID: null,
          detailType: "InsurerBillingQC",
        })
      );
      clearDuration(dispatch);
      clearCurrentPage(dispatch);
      setHeader([]);
    }
  };

  console.log("payableData",payableData)


  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          {(rowData?.detailType === "TestDetail" || rowData?.detailType==="AppPriceDetail" ||searchFilter.detailType==rowData?.detailType.replace(/\s+/g, '')) &&
          rowData?.facilityType === "TEST" ? (
            <TestDetailsPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          ) : (rowData?.detailType === "PackageDetail" || rowData?.detailType==="AppPriceDetail") &&
            rowData?.facilityType === "PACKAGE" ? (
            <PackageDetailsPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          ) : rowData?.detailType === "TestDetailIBU" &&
            rowData?.facilityType === "TEST" ? (
            <TestDetailsPopupIBU
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          ) : rowData?.detailType === "PackageDetailIBU" &&
            rowData?.facilityType === "PACKAGE" ? (
            <PackageDetailPopupIBU
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          ) : rowData?.detailType === "ProviderDocument" ? (
            <ProviderUploadDocPopupIBU
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          ) : (
            <div>
              <h4> Provider Details </h4>
              {rowData !== null &&
                (rowData?.detailType === "FinanceQC" ||
                  rowData?.detailType === "InsurerBillingQC" || rowData?.detailType === "ProviderQC") && (
                  <div
                    className="back-buttondiv"
                    onClick={handleBackButton}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-circle-arrow-left"></i>
                    <h6>Back</h6>
                  </div>
                )}
              <div className="row-filter">
                <input
                  type="number"
                  placeholder="Request ID"
                  className="white-form-select"
                  disabled={rowData?.detailType === "FinanceQC"}
                  value={
                    searchFilter?.requestID === null
                      ? ""
                      : searchFilter?.requestID
                  }
                  onChange={(e) =>
                    changeHandler(
                      "requestID",
                      e.target.value === "" ? null : e.target.value
                    )
                  }
                />
                {rowData?.detailType !== "InsurerBillingQC" && (
                  <input
                    type="text"
                    placeholder="Provider's Name"
                    className="white-form-select"
                    value={searchFilter?.providerName}
                    onChange={(e) =>
                      changeHandler("providerName", e.target.value)
                    }
                  />
                )}
                <select
                  className="white-form-select"
                  value={searchFilter?.detailType}
                  disabled={rowData?.detailType === "FinanceQC"}
                  onChange={(e) => {
                    changeHandler("detailType", e.target.value);
                  }}
                >
                  <option value="">Detail Type</option>
                  {getProviderPortalDetails?.getDetailType?.map((ele) => (
                    <option value={ele?.code}>{ele?.shortDesc}</option>
                  ))}
                </select>
                <select
                  className="white-form-select"
                  value={searchFilter?.requestStatus}
                  onChange={(e) =>
                    changeHandler("requestStatus", e.target.value)
                  }
                >
                  <option value="">Status</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Pending"> Pending for Approval</option>
                  <option value="Partial">Partial</option>
                </select>
                {qcFinancePage !== "firstPage" &&
                  qcFinancePage !== "secondPage" && (
                    <div className="dashbaord-date">
                      <DateRangePickerInput />
                    </div>
                  )}

                <div className="search" type="button" onClick={handleSearch}>
                  <a className="sidebar-links">
                    <SearchIcon />
                    <span className="sidebar-link-text">Search</span>
                  </a>
                </div>
                {qcFinancePage !== "firstPage" &&
                  qcFinancePage !== "secondPage" && (
                    <button
                      className="search"
                      type="button"
                      onClick={handleClearFilter}
                      disabled={
                        qcFinancePage === "firstPage" ||
                        qcFinancePage === "secondPage"
                      }
                      style={{ border: "none" }}
                    >
                      <a className="sidebar-links">
                        <span className="sidebar-link-text">Clear All</span>
                      </a>
                    </button>
                  )}
              </div>
              {rowData === null && (
                <>
                  <div className="row-results">
                    <div className="results">
                      Total <span>{globalReducer?.getTotalCount}</span> results
                    </div>
                    <div>
                      <button
                        className="dropdown-toggle appointment-dropdown"
                        style={{ width: "160px" }}
                        type="button"
                        id="dropdownMenu2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>
                          {searchFilter?.SortDirection === "asc"
                            ? "Ascending Order"
                            : "Descending Order"}
                        </span>
                        <i className="fa fa-list"></i>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenu2"
                      >
                        <li>
                          <button
                            className="dropdown-item btn-border-bottom"
                            type="button"
                            onClick={() => handleSorting("asc")}
                          >
                            Ascending Order
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            type="button"
                            onClick={() => handleSorting("desc")}
                          >
                            Descending Order
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-responsive __custom__properties">
                    <table className="table" style={{ overflow: "hidden" }}>
                      <thead>
                        <tr>
                          <th scope="col">Sr No.</th>
                          <th scope="col">Name</th>
                          <th scope="col">Request ID</th>
                          <th scope="col">Detail Type</th>
                          <th scope="col">Submitted On</th>
                          <th scope="col">Status</th>
                          <th scope="col">History</th>
                          <th scope="col">Last Updated By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getProviderPortalDetails?.getProviderPortalDetails.map(
                          (ele, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ fontWeight: "bold" }}>
                                  {ele?.rowNum}
                                </td>
                                <td className="width-200">
                                  <a
                                    className="text-highlighted text-decoration"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      console.log("els",ele)
                                      setRowData(ele);
                                      setFirstPageData(ele);
                                      setIsReCall(true);
                                    }}
                                  >
                                    {ele?.providerName}
                                  </a>
                                </td>
                                <td>{ele?.requestID}</td>
                                <td>
                                  {ele?.detailType?.replace(
                                    /([a-z])([A-Z])/g,
                                    "$1 $2"
                                  )}
                                </td>
                                <td>
                                  {moment(ele?.createdDate).format(
                                    "DD MMMM YYYY"
                                  )}
                                </td>
                                <td className="width-80">
                                  {ele?.requestStatus !== "" && (
                                    <p
                                      className={`status-style ${
                                        ele?.requestStatus === "Approved" ||
                                        ele?.requestStatus === "Paid"
                                          ? "approved"
                                          : ele?.requestStatus === "Rejected" ||
                                            ele?.requestStatus ===
                                              "Reject By Finance" ||
                                            ele?.requestStatus === "Not Paid "
                                          ? "rejected"
                                          : ele?.requestStatus ===
                                              "Pending At Finance" ||
                                            ele?.status === "Pending at Network"
                                          ? "pendingAtFinance"
                                          : ele?.requestStatus ===
                                            "Pending For Payment"
                                          ? "pendingForpayment"
                                          : ele?.requestStatus ==="Pending For Provider" ? "refundStatus"
                                          : ele?.requestStatus === "Rejected By Provider" ? "rejected"
                                          : "pending"
                                      }`}
                                    >
                                      {ele?.requestStatus ===
                                      "Pending for Approval"
                                        ? "Pending"
                                        : ele?.requestStatus}
                                    </p>
                                  )}
                                </td>
                                <td className="width-80">
                                  <a
                                    className="text-decoration text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setRowTicketId(ele)}
                                  >
                                    View
                                  </a>
                                </td>
                                <td> {ele?.updatedBy}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              {(rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC") &&
                qcFinancePage === "firstPage" && (
                  <FinanceQcPopup
                    rowData={rowData}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    apiParams={apiParams}
                    setRowData={setRowData}
                    setQcFinancePage={setQcFinancePage}
                    reCallApi={reCallApi}
                    setReCallApi={setReCallApi}
                    payableData={payableData}
                    setPayabelData={setPayabelData}
                    firstPageData={firstPageData}
                    
                  />
                )}
              {(rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC") &&
                qcFinancePage === "secondPage" && (
                  <FinanceAppointment
                    rowData={rowData}
                    searchFilter={searchFilter}
                    setRowData={setRowData}
                    payableData={payableData}
                    setPayabelData={setPayabelData}
                    header={header}
                    setHeader={setHeader}
                    showData={showData}
                    setShowData={setShowData}
                    setSearchFilter={setSearchFilter}
                  />
                )}
              {rowData?.detailType === "InsurerBillingQC" &&
                insBillingPage === "firstPage" && (
                  <InsurerBillingClient
                    rowData={rowData}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    apiParams={apiParams}
                    setRowData={setRowData}
                    reCallApi={reCallApi}
                    setReCallApi={setReCallApi}
                    payableData={payableData}
                    setPayabelData={setPayabelData}
                    firstPageData={firstPageData}
                    setInsBillingPage={setInsBillingPage}
                    invoice={invoice}
                    setInvoice={setInvoice}
                  />
                )}
              {rowData?.detailType === "InsurerBillingQC" &&
                insBillingPage === "secondPage" && (
                  <InsurerBillingAppointment
                    rowData={rowData}
                    searchFilter={searchFilter}
                    setRowData={setRowData}
                    payableData={payableData}
                    setPayabelData={setPayabelData}
                    header={header}
                    setHeader={setHeader}
                    showData={showData}
                    setShowData={setShowData}
                    setSearchFilter={setSearchFilter}
                  />
                )}

              <div className="d-flex justify-content-between">
                <div className="pagination-row">
                  {globalReducer?.getTotalCount !== 0 && (
                    <PaginatedItems
                      totalCount={globalReducer?.getTotalCount}
                      perPageData={searchFilter?.rows}
                    />
                  )}
                </div>

                

                {getNetworkMenuId()?.canEdit === true && (
                  <>
                    {(rowData?.detailType === "FinanceQC" || 
                    (rowData?.detailType === "ProviderQC" && rowData.requestStatus!=="Pending For Provider" )) &&
                      (qcFinancePage === "firstPage" ||
                        qcFinancePage === "secondPage") && (
                        <div className="pagination-row">
                          <button
                            className="btn search__btn "
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#createPayable"
                            disabled={payableData.length === 0 }
                            style={{ backgroundColor: "#5157A0" }}
                          >
                            Create Payable{" "}
                            <i class="fa-solid fa-caret-right"></i>
                          </button>
                        </div>
                      )}
                  </>
                )}
                {getNetworkMenuId()?.canEdit === true && (
                  <>
                    {rowData?.detailType === "InsurerBillingQC" &&
                      insBillingPage === "secondPage" && (
                        <div className="pagination-row">
                          <button
                            className="btn search__btn "
                            type="button"
                            // data-bs-toggle="modal"
                            // data-bs-target="#createPayable"
                            disabled={payableData.length === 0}
                            onClick={() => {
                              setInvoice({ isOpen: true, rowData: "" });
                            }}
                            style={{ backgroundColor: "#5157A0" }}
                          >
                            Receivable Payable{" "}
                            <i class="fa-solid fa-caret-right"></i>
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            </div>
          )}
          <Modal
            isOpen={
              rowData !== null && rowData?.detailType === "ProfileVerification"
            }
            className="modal-page-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <VerificationDetailsPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          </Modal>
          <Modal
            isOpen={rowData !== null && rowData?.detailType === "ProfileDetail"}
            className="modal-page-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <ProfileDetailPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          </Modal>
          <Modal
            isOpen={
              rowData !== null && rowData?.detailType === "InfrastructureDetail"
            }
            className="modal-page-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <InfrastructurePopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          </Modal>
          <Modal
            isOpen={rowData !== null && rowData?.detailType === "PaymentDetail"}
            className="modal-page-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <PaymentDetailsPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          </Modal>
          <Modal
            isOpen={rowData !== null && rowData?.detailType === "StaffDetail"}
            className="modal-page-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <StaffDetailsPopup
              rowData={rowData}
              searchFilter={searchFilter}
              apiParams={apiParams}
              setRowData={setRowData}
            />
          </Modal>

          <Modal
            isOpen={rowTicketId !== null}
            className="modal-history-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <HistoryDetailsPopup
              rowTicketId={rowTicketId}
              setRowTicketId={setRowTicketId}
            />
          </Modal>
          <div
            class="modal fade"
            id="createPayable"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <CreatePayablePopup
              setQcFinancePage={setQcFinancePage}
              qcFinancePage={qcFinancePage}
              payableData={payableData}
              setPayabelData={setPayabelData}
              rowData={rowData}
              searchFilter={searchFilter}
              firstPageData={firstPageData}
              setFirstPageData={setFirstPageData}
              insBillingPage={insBillingPage}
              setInsBillingPage={setInsBillingPage}
            />
          </div>
          <div
            class="modal fade"
            id="additionalFilterApptHeader"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <AdditionalFinanceApptHeader
              setQcFinancePage={setQcFinancePage}
              qcFinancePage={qcFinancePage}
              payableData={payableData}
              setPayabelData={setPayabelData}
              rowData={rowData}
              searchFilter={searchFilter}
              header={header}
              setHeader={setHeader}
            />
          </div>
          <Modal
            isOpen={invoice?.isOpen}
            className="modal-add-user-popup   bankDetailwidth"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <UpdateInvoice
              searchFilter={searchFilter}
              invoice={invoice}
              setInvoice={setInvoice}
              payableData={payableData}
              setPayabelData={setPayabelData}
              rowData={rowData}
              firstPageData={firstPageData}
              insBillingPage={insBillingPage}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ProviderProfileDetails;
